import { Probe } from "@/pages/heat-report/models/HeatReportModels";
import { ProcessCodeTag } from "@/shared/data-entries/ProcessCodeTag";
import { dxtToLocalServerTime, getMomentTz } from "@dexteel/mesf-core";
import {
  ColDef,
  ColGroupDef,
  ICellRendererParams,
  ValueGetterParams,
} from "ag-grid-enterprise";
const moment = getMomentTz();

export const useTableData = () => {
  const columns: ColGroupDef[] = [
    {
      headerName: "Probes",
      children: [
        {
          field: "actions",
          headerName: " ",
          flex: 1,
          minWidth: 45,
          cellRenderer: (params: ICellRendererParams<Probe>) => {
            const processCode = params?.data?.ProcessCode;
            if (processCode === "L") {
              return <ProcessCodeTag label="LMF" />;
            }
            return null;
          },
        },
        {
          field: "Timestamp",
          headerName: "Time",
          flex: 2,
          valueGetter: (params: ValueGetterParams<Probe>) => {
            if (params?.data?.Timestamp) {
              return dxtToLocalServerTime(params?.data?.Timestamp, "HH:mm");
            }
          },
        },
        {
          field: "Temperature",
          headerName: "Temp",
          valueGetter: (params: ValueGetterParams<Probe>) =>
            params.data?.Temperature?.toFixed(0) || "0",
          flex: 2,
        },
        {
          field: "SuperHeat",
          headerName: "SH",
          valueGetter: (params: ValueGetterParams<Probe>) =>
            params.data?.SuperHeat?.toFixed(0) || "0",
          flex: 2,
        },
      ],
    },
  ];

  return { columns };
};
